<div class="mr-large-t">
  @if (informationalTeaser().teaserTitle !== '') {
    <div class="nordic-blue-900-text text-icon-primary ms-large-b font-body-medium-bold">
      {{ informationalTeaser().teaserTitle }}
    </div>
    <div class="ms-medium-b" [innerHTML]="informationalTeaser().teaserText | finSafe: 'html'"></div>
  }
  @if (informationalTeaser().items.length > 0) {
    <div
      class="grid-col-12 no-gutters ms-large-b informational-images"
      [class.informational-images--single]="isSingleImage()"
      [class.informational-images--multiple]="!isSingleImage()"
    >
      @for (contentImage of informationalTeaser().items; track $index) {
        <fin-content-image
          class="block image-height informational-image elevation-level-1 col-1-12 ms-small-b"
          [imageData$]="contentImage | finToObservable"
          [aspectRatio$]="(isSingleImage() ? '21x9' : '1x1') | finToObservable"
        />
      }
    </div>
  }
  @if (informationalTeaser().localSettings.extraText) {
    <div class="ms-medium-t font-body-medium">
      {{ informationalTeaser().localSettings.extraText }}
    </div>
  }
</div>
